import { useMemo } from 'react';
import getFlatChildren from '../helpers/get-flat-children';
import isGroupedItems from '../helpers/is-grouped-items';

function useTreeSelectData(items) {
  return useMemo(() => {
    const idToItem = new Map();
    const searchValues = new Map();
    const itemAncestors = new Map();
    const descendantItemIds = new Map();
    const selectableDescendantItemIds = new Map();
    const selectableIds = new Set();

    function visitItem(item, ancestorItemIds) {
      idToItem.set(item.id, item);
      searchValues.set(item.id, item.value.toLowerCase());
      itemAncestors.set(item.id, ancestorItemIds);

      if (!item.items || item.items.length === 0) {
        if (!item.disabled) {
          selectableIds.add(item.id);
        }

        return {
          allItemIds: [item.id],
          selectableLeafIds: item.disabled ? [] : [item.id],
        };
      }

      const children = getFlatChildren(item.items);
      const childAncestors = [item.id, ...ancestorItemIds];

      const allDescendantItemIds = [];
      const selectableDescendantIds = [];

      children.forEach((child) => {
        const result = visitItem(child, childAncestors);
        allDescendantItemIds.push(...result.allItemIds);
        selectableDescendantIds.push(...result.selectableLeafIds);
      });

      descendantItemIds.set(item.id, allDescendantItemIds);
      selectableDescendantItemIds.set(item.id, selectableDescendantIds);

      return {
        allItemIds: [item.id, ...allDescendantItemIds],
        selectableLeafIds: selectableDescendantIds,
      };
    }

    const topLevelItems = isGroupedItems(items) ? items.flatMap((g) => g.items) : items;

    topLevelItems.forEach((item) => visitItem(item, []));

    return {
      idToItem,
      searchValues,
      itemAncestors,
      descendantItemIds,
      selectableDescendantItemIds,
      selectableIds,
    };
  }, [items]);
}

export default useTreeSelectData;
